import { UserDTO } from "../api/Api";
import { API } from "../config/api";

class UserService {
  async getUser() {
    try {
      let res = API.api.getUser();
      let result = (await res).data as UserDTO;
      return result;
    } catch (err: any) {
      console.error(err);
      return {};
    }
  }
}

export const userService: UserService = new UserService();
